export function ArrowDown2Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.0893 6.57745C18.4147 6.90289 18.4147 7.43053 18.0893 7.75596L10.5893 15.256C10.2639 15.5814 9.73622 15.5814 9.41078 15.256L1.91078 7.75596C1.58535 7.43053 1.58535 6.90289 1.91078 6.57745C2.23622 6.25201 2.76386 6.25201 3.0893 6.57745L10 13.4882L16.9108 6.57745C17.2362 6.25201 17.7639 6.25201 18.0893 6.57745Z"
        fill="currentColor"
      />
    </svg>
  );
}
